import { createSlice } from "@reduxjs/toolkit";
// eslint-disable-next-line no-duplicate-imports
import type { PayloadAction } from "@reduxjs/toolkit";


interface LoginState {
  canRequestNewPin: boolean;
  otpSendingInProgress?: boolean;
  resetPasswordEnabled: boolean;
  recaptchaV2SiteKey?: string;
}

const initialState: LoginState = {
  canRequestNewPin: false,
  resetPasswordEnabled: true
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    requestNewPin(state, action) {
      return state;
    },
    toggleRequestingNewPin: {
      reducer: (state, action: PayloadAction<any>) => {
        state.canRequestNewPin = action.payload.canRequestNewPin;
        state.otpSendingInProgress = action.payload.otpSendingInProgress;
      },
      prepare: (canRequestNewPin: boolean, otpSendingInProgress: boolean) => {
        return {
          payload: {
            canRequestNewPin,
            otpSendingInProgress
          }
        };
      }
    },
    setResetPasswordEnabled(state, action: PayloadAction<boolean>) {
      state.resetPasswordEnabled =  action.payload;
    },
    setRecaptchaV2SiteKey(state, action: PayloadAction<string>) {
      state.recaptchaV2SiteKey = action.payload;
    },
    destroy() {
      return {
        ...initialState
      };
    }
  }
});


export default loginSlice.reducer;
export const {
  requestNewPin,
  toggleRequestingNewPin,
  setRecaptchaV2SiteKey,
  destroy
} = loginSlice.actions;
export const loginActions = loginSlice.actions;
